// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML, sendXHR, failedRequest } from 'src/lib/utils.js';


// Binds

// Stateful components

export const ReactPieChart = (props) => {

    let {result, noColor} = props;

    //let result = Number( props.result );
    let subText = '';
    let resultClass = 'br-app-pie__result';

    let borderClass = ' half-circle--weakness';
    let pieStyles = {};
    let leftStyles = {};
    let rightStyles = {};

    if (isNaN(result)) { 
        result = 'Not completed';
        resultClass += ' br-app-pie__result--long'
    } else {
        leftStyles = {
            'transform': `rotate(${result * 3.6}deg)`
        };

        if (typeof(noColor) !== 'undefined') {
            borderClass = ' half-circle--strength';
        } else {
            if (result > 66) {
                borderClass = ' half-circle--strength';
            } else if (result > 33) {
                borderClass = ' half-circle--improvement';
            }
        }
        
        if (result <= 50) {
            rightStyles['display'] = 'none';
        } else {
            pieStyles['clip'] = 'rect(auto, auto, auto, auto)';
            rightStyles['transform'] = 'rotate(180deg)';
        }

        result = result + '%';
        subText = '<span class="br-app-pie__label-text">Strengths</span>';
    }
    
    return (
        <div className="br-app-pie__wrapper">

            <div className="br-app-pie__label">
                <span className={resultClass}>{result}</span>
                <div dangerouslySetInnerHTML={dangerousHTML(subText)}></div>
            </div>

            <div className="br-app-pie" style={pieStyles}>
                
                <div className={"left-side half-circle" + borderClass} style={leftStyles}></div>

                <div className={"right-side half-circle" + borderClass} style={rightStyles}></div>

            </div>

            <div className="br-app-pie__shadow"></div>
        </div>
    );
};
